import { Component, EventEmitter, inject, OnDestroy, Output } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { GpsService, GpsQuality } from '../../services/gps.service';
import { Subscription } from 'rxjs';

/**
 * Standalone GPS-Status-Indikator.
 * Zeigt GPS-Qualität mit 5 Zuständen (None, Accurate, Slow, Bad, BadAndSlow).
 */
@Component({
	selector: 'wd-gps-status',
	standalone: true,
	imports: [NgbTooltipModule],
	template: `
		<button class="btn btn-status" placement="start"
			[ngbTooltip]="gpsMessage" tooltipClass="custom-tooltip-class"
			(click)="gpsClicked.emit()">
			@switch (quality) {
				@case (GQ.None) {
					<div class="icon-overlay">
						<i class="bi bi-geo-alt base-icon"></i>
						<i class="bi bi-x-square-fill overlay-icon" style="color: red"></i>
					</div>
				}
				@case (GQ.Accurate) {
					<div class="icon-overlay">
						<i class="bi bi-geo-alt base-icon"></i>
						<i class="bi bi-check overlay-icon" style="color: green"></i>
					</div>
				}
				@case (GQ.Slow) {
					<div class="icon-overlay">
						<i class="bi bi-geo-alt base-icon"></i>
						<i class="bi bi-speedometer2 overlay-icon" style="color: lightgreen"></i>
					</div>
				}
				@case (GQ.Bad) {
					<div class="icon-overlay">
						<i class="bi bi-geo-alt base-icon"></i>
						<i class="bi bi-exclamation-triangle-fill overlay-icon" style="color: lightgreen"></i>
					</div>
				}
				@case (GQ.BadAndSlow) {
					<div class="icon-overlay">
						<i class="bi bi-geo-alt base-icon"></i>
						<i class="bi bi-speedometer2 overlay-icon" style="color: yellow"></i>
					</div>
				}
			}
		</button>
	`,
	styles: [`
		.btn-status { padding-left: 0.1rem; border-style: none; }
		.icon-overlay { position: relative; }
		.overlay-icon { position: absolute; bottom: -5px; right: -5px; font-size: 12px; }
	`]
})
export class WdGpsStatusComponent implements OnDestroy {
	GQ = GpsQuality;
	quality = GpsQuality.None;
	@Output() gpsClicked = new EventEmitter<void>();

	private sub: Subscription;

	constructor() {
		const gps = inject(GpsService);
		this.sub = gps.monitor().subscribe(q => this.quality = q);
	}

	get gpsMessage(): string {
		switch (this.quality) {
			case GpsQuality.Accurate: return 'Gutes GPS-Signal';
			case GpsQuality.None: return 'Kein GPS-Signal!';
			case GpsQuality.Slow: return 'Verzögertes GPS-Signal!';
			case GpsQuality.Bad: return 'Ungenaues GPS-Signal!';
			case GpsQuality.BadAndSlow: return 'Ungenaues und verzögertes GPS-Signal!';
		}
	}

	ngOnDestroy() { this.sub.unsubscribe(); }
}
